





































































import { Vue, Component, State, namespace, Inject } from 'nuxt-property-decorator'
import dayjs from 'dayjs'
import FilterButton from '~/components/experience/search-filter/desktop/filter-button.vue'
import ExperienceFilterPrice from '~/components/experience/search-filter/filter-price.vue'
import ExperienceFilterModal from '~/components/experience/search-filter/desktop/filter-modal.vue'
import ExperienceDate from '~/components/experience/search-filter/filter-date.vue'

import { Experience } from '~/types/experience'

import UrlQuery = Experience.UrlQuery

const experience = namespace('experience')

@Component({
  components: {
    FilterButton,
    ExperienceFilterPrice,
    ExperienceFilterModal,
    ExperienceDate
  }
})

export default class ExperiencesFilterOptions extends Vue {
  @State klook!: Data.Klook
  @experience.Action setUrlQuery!: Function
  @experience.State urlQuery!: UrlQuery
  @experience.State priceTo!: number
  @Inject({ default: (_: any) => _ }) resetPage!: Function

  instant: boolean = false
  dateShow: boolean = false
  priceShow: boolean = false
  dateActive: boolean = false
  priceActive: boolean = false

  checkboxChange(val: boolean) {
    this.resetPage && this.resetPage()
    this.setUrlQuery({
      instant: Number(val),
      page: 1
    })
    this.$inhouse.updateBinding((this.$refs?.instantBtn as Vue)?.$el, {
      ext: JSON.stringify({
        InstantConfirmation: val
      })
    })
    this.$inhouse.track('virtualAction', (this.$refs?.instantBtn as Vue)?.$el)
  }

  get priceText() {
    const price: number [] = [Number(this.urlQuery.price_from) || 0, Number(this.urlQuery.price_to) || 0]
    if (!price[0] && !price[1]) {
      this.priceActive = false
      return this.$t('13764')
    }
    if (price[0] > 0 && price[1] === 0) {
      price[1] = this.priceTo
    }
    this.priceActive = true
    return `${this.klook.currencySymbol}${price[0]} - ${this.klook.currencySymbol}${price[1]}${price[1] === this.priceTo ? '+' : ''}`
  }

  get dateText() {
    if (this.urlQuery.start_date) {
      this.dateActive = true
      return dayjs(this.urlQuery.start_date).format('YYYY/MM/DD')
    } else {
      this.dateActive = false
      return this.$t('2424')
    }
  }

  showDate() {
    this.dateShow = !this.dateShow
  }

  showPrice() {
    this.priceShow = !this.priceShow
  }

  mounted() {
    this.instant = !!Number(this.urlQuery.instant)
  }
}
